export const VueGallerySlideshowNew = {
  template: `
  <transition name="modal">
    <div
      v-if="imgIndex !== null"
      class="vgs"
      @click="picture360 && imgIndex == 0 ? '' : close() "
    >
      <button
        type="button"
        class="vgs__close"
        @click="close"
      >
        &times;
      </button>
      <button
        v-if="isMultiple"
        type="button"
        class="vgs__prev"
        @click.stop="onPrev"
      >
        &lsaquo;
      </button>
      <div
        v-if="images"
        class="vgs__container top-img flex items-center justify-center"
      >  
        <iframe v-if="isSelectedMp4" :src="media" controls="true" width="80%" style="background:#ffffff;margin: 0 auto;" class="h-[42vw] 2xl:h-[630px] 2xl:w-[1220px]">
        </iframe>   
        <Pano v-else-if="isSelected360" :source="imageUrl"></Pano>
        <div v-else class="vgs__container__img">
            <picture>
            <source v-if="imageUrl && (imageUrl.toLowerCase().indexOf('cardealerstg.blob.core.windows.net') !== -1 || imageUrl.toLowerCase().indexOf('dealerphotocdn.azureedge.net') !== -1)" :srcset="imageUrl.replace(/-gallery/g, '-large').replace('.jpg','.webp')" type="image/webp"/>
            <source :srcset="imageUrl.replace(/-gallery/g, '-large')" type="image/jpg"/>
            <img
              class="vgs__container__img"
              :src="imageUrl.replace(/-gallery/g, '-large')"
              :alt="alt"
              @click.stop="onNext"
            >
            </picture>
        </div>
        <slot></slot>
      </div>
      <button
        v-if="isMultiple"
        type="button"
        class="vgs__next"
        @click.stop="onNext"
      >
        &rsaquo;
      </button>
      <div
        v-if="isMultiple"
        ref="gallery"
        class="vgs__gallery"
      >
        <div
          v-if="images"
          class="vgs__gallery__title"
        >
          {{ imgIndex + 1 }} / {{ images.length }}
        </div>
        <div
          v-if="images"
          class="vgs__gallery__container"
          :style="{ transform: 'translate(' + galleryXPos + 'px, 0)' }"
        >
        <span  v-for="(img, i) in images">
          <img v-if="videomp4 == true && i==0"
            :key="i"
            class="vgs__gallery__container__img bg-white p-4"
            src="https://static.leadboxhq.com/v5cdn/components/gallery/video.svg"
            :class="{ 'vgs__gallery__container__img--active': i === imgIndex}"
            :alt="typeof img === 'string' ? '' : img.alt"
            @click.stop="onClickThumb(img, i)"
          >
          <img v-else-if="(picture360 == true && i==0 && !videomp4) || (videomp4 && picture360 == true && i==1)"
            :key="i"
            class="vgs__gallery__container__img bg-white p-4"
            src="https://static.leadboxhq.com/v5cdn/components/gallery/360.svg"
            :class="{ 'vgs__gallery__container__img--active': i === imgIndex}"
            :alt="typeof img === 'string' ? '' : img.alt"
            @click.stop="onClickThumb(img, i)"
          >

          <img v-else
            :key="i"
            class="vgs__gallery__container__img"
            :src="typeof img === 'string' ? img.replace(/-XXL/g, '-thumb.jpg') : img.url.replace(/-XXL/g, '-thumb.jpg')"
            :class="{ 'vgs__gallery__container__img--active': i === imgIndex}"
            :alt="typeof img === 'string' ? '' : img.alt"
            @click.stop="onClickThumb(img, i)"
          >

          </span>
        </div>
      </div>
    </div>
  </transition>
`,
  props: {
    images: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: false,
      default: null
    },
    picture360: {
      type: Boolean,
      required: false,
      default: false
    },
    videomp4: {
      type: Boolean,
      required: false,
      default: false
    },
    media: {
      type: String,
      required: '',
      default: ''
    }
  },
  data() {
    return {
      imgIndex: this.index,
      image: null,
      galleryXPos: 0,
      thumbnailWidth: 120,
      isSelected360: false,
      isSelectedMp4: false
    };
  },
  created: function () {
    //console.log("Created");
  },
  computed: {
    imageUrl() {
      this.validateImages();
      const img = this.images[this.imgIndex];
      if (typeof img === "string") {
        return img;
      }
      return img;

    },
    videoUrl() {
      //console.log('entromp4');
      return this.media;
    },
    alt() {
      const img = this.images[this.imgIndex];
      if (typeof img === "object") {
        return img.alt;
      }

      return "";
    },
    isMultiple() {
      return this.images.length > 1;
    }
  },
  watch: {
    index(val, prev) {
      this.imgIndex = val;

      // updateThumbails when popup
      if (prev == null && val != null) {
        this.$nextTick(() => {
          this.validateImages();
          this.updateThumbails();
        });
      }
    }
  },
  mounted() {
    window.addEventListener("keydown", e => {
      if (e.keyCode === 37) {
        this.onPrev();
      } else if (e.keyCode === 39) {
        this.onNext();
      } else if (e.keyCode === 27) {
        this.close();
      }
    });
  },
  methods: {
    close() {
      const eventData = {
        imgIndex: this.imgIndex
      };
      this.imgIndex = null;
      this.$emit("close", eventData);
    },
    validateImages(){
      if (this.picture360 && ((this.imgIndex == 1 && this.videomp4) || (this.imgIndex == 0 && !this.videomp4))) {
        this.isSelected360 = true;
      } else {
        this.isSelected360 = false;
      }
      if (this.videomp4 && this.imgIndex == 0){
        this.isSelectedMp4 = true;
      } else {
        this.isSelectedMp4 = false;
      }
    },
    onPrev() {
      if (this.imgIndex === null) return;
      if (this.imgIndex > 0) {
        this.imgIndex--;
      } else {
        this.imgIndex = this.images.length - 1;
      }
      this.validateImages();
      this.updateThumbails();
    },
    onNext() {
      if (this.imgIndex === null) return;
      if (this.imgIndex < this.images.length - 1) {
        this.imgIndex++;
      } else {
        this.imgIndex = 0;
      }
      this.validateImages();
      this.updateThumbails();
    },
    onClickThumb(image, index) {
      this.imgIndex = index;
      this.validateImages();
      this.updateThumbails();
    },
    updateThumbails() {
      if (!this.$refs.gallery) {
        return;
      }

      const galleryWidth = this.$refs.gallery.clientWidth;
      const currThumbsWidth = this.imgIndex * this.thumbnailWidth;
      const maxThumbsWidth = this.images.length * this.thumbnailWidth;
      const centerPos =
        Math.floor(galleryWidth / (this.thumbnailWidth * 2)) *
        this.thumbnailWidth;

      // Prevent scrolling of images if not needed
      if (maxThumbsWidth < galleryWidth) {
        return;
      }

      if (currThumbsWidth < centerPos) {
        this.galleryXPos = 0;
      } else if (
        currThumbsWidth >
        this.images.length * this.thumbnailWidth - galleryWidth + centerPos
      ) {
        this.galleryXPos = -(
          this.images.length * this.thumbnailWidth -
          galleryWidth -
          20
        );
      } else {
        this.galleryXPos = -(this.imgIndex * this.thumbnailWidth) + centerPos;
      }
    }
  }
};